import React from 'react';
import PropTypes from 'prop-types';
import {withFirebase} from 'react-redux-firebase';

import {SlideContainer} from '../../common/slideshow';
import {styles, Countdown} from '../../common';
import {handleClick} from '../../../util/eventHelper';
import firebaseUtils from '../../../util/FirebaseUtils';

import logo from '../../../assets/images/logo-Spiria.png';

class SpocImageSlide extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getImage = this.getImage.bind(this);

        this.state = {
            imageUrl: null
        };
    }

    componentDidMount() {
        this.getImage();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.image !== this.props.image) {
            this.getImage();
        }
    }

    getImage() {
        const imageToUse = this.props.spocImage || this.props.defaultSpocImage; 

        firebaseUtils.getImageUrl(this.props.firebase, imageToUse)
            .then(imageUrl => this.setState({imageUrl: imageUrl || logo}));
    }

    render() {
        const {SpocBackgroundColor, spocImageSettingsFields, isCountdown, onLoad, time, urlLink, ...rest} = this.props;
        return (
            <SlideContainer
                className="image-only"
                containerStyle={{backgroundColor : SpocBackgroundColor || "#ffffff"}}
                {...rest}
            >
                <div onClick={() => handleClick(urlLink)}>
                    {do {
                        if (time && isCountdown) {
                            <Countdown time={time}/>;
                        }
                    }}
                    <img
                        alt="full-slide"
                        className="image"
                        onLoad={onLoad}
                        src={this.state.imageUrl}
                        style={styles.slideImage(spocImageSettingsFields)}
                    />
                </div>
            </SlideContainer>
        );
    }
}

SpocImageSlide.propTypes = {
    SpocBackgroundColor: PropTypes.string,
    image: PropTypes.string,
    spocImageSettingsFields: PropTypes.object,
    onLoad: PropTypes.func,
    urlLink : PropTypes.string
};

export default withFirebase(SpocImageSlide);



// WEBPACK FOOTER //
// ./src/components/dashboard/slides/SpocImageSlide.js